// Third-party usage analytics is disabled.
//
// This app previously sent events to Mixpanel tied to the individual participant
// (page views, Play/Pause clicks on the video and, per quiz question, whether the
// answer was correct, which attempt it was and how long it took). Breefer acts as a
// data processor for the customer and may only process participants' data on the
// customer's instructions - product analytics is our own purpose, not theirs. On top
// of that, the identifier Mixpanel stored in localStorage required consent, the app
// has no consent mechanism, and `ignore_dnt` overrode the browser's Do Not Track
// setting. Events were also sent to Mixpanel's US endpoint, with no EU data residency
// configured.
//
// The call sites across the app are kept on purpose, so this change touches one file
// instead of fifteen: every call below is now a no-op. If usage analytics is
// reintroduced, it must not identify individuals and must be behind consent.
const actions = {
  identify: (_id: string) => {},
  alias: (_id: string) => {},
  track: (_name: string, _props?: any) => {},
  reset: () => {},
  people: {
    set: (_props: any) => {},
  },
  trackpageView: (_pageName: string) => {},
};

export default actions;
